// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/webpack/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".message-card>.card-body[data-v-9b2c61fc]{padding:.5rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
